import React, { useState } from 'react';

const DebugPanel: React.FC = () => {
  const [tab, setTab] = useState<'dashboard' | 'settleup'>('dashboard');
  const debugInfo = (window as any).debugInfo || {};
  const settleUpDebugInfo = (window as any).settleUpDebugInfo || {};

  return (
    <div 
      style={{
        position: 'fixed',
        top: '100px',
        left: '10px',
        right: '10px',
        maxHeight: '70vh',
        background: 'rgba(0, 0, 0, 0.95)',
        color: 'var(--color-success)',
        padding: '20px',
        borderRadius: '12px',
        fontFamily: 'monospace',
        fontSize: '12px',
        overflow: 'auto',
        zIndex: 9999,
        boxShadow: '0 8px 32px rgba(0,0,0,0.5)'
      }}
    >
      <div style={{ marginBottom: '15px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, color: 'var(--color-success)' }}>🐛 Debug Info</h3>
          <div style={{ fontSize: '11px', color: 'var(--color-text-tertiary)', fontStyle: 'italic' }}>
            Press Ctrl+Shift+D (or Cmd+Shift+D) to close
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
        <button
          onClick={() => setTab('dashboard')}
          style={{
            background: tab === 'dashboard' ? '#00ff00' : '#333',
            color: tab === 'dashboard' ? '#000' : '#00ff00',
            border: '1px solid #00ff00',
            padding: '5px 15px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Dashboard
        </button>
        <button
          onClick={() => setTab('settleup')}
          style={{
            background: tab === 'settleup' ? '#00ff00' : '#333',
            color: tab === 'settleup' ? '#000' : '#00ff00',
            border: '1px solid #00ff00',
            padding: '5px 15px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Settle Up
        </button>
      </div>

      {tab === 'dashboard' ? (
        <div style={{ lineHeight: '1.6' }}>
        <div><strong>Group:</strong> {debugInfo.groupName}</div>
        <div><strong>Group ID:</strong> {debugInfo.groupId}</div>
        <div><strong>Your User ID:</strong> {debugInfo.userId}</div>
        <div><strong>Your Name:</strong> {debugInfo.userName}</div>
        <div style={{ marginTop: '10px' }}><strong>Total Expenses Found:</strong> {debugInfo.totalExpenses}</div>
        
        {debugInfo.expenses && debugInfo.expenses.length > 0 ? (
          <div style={{ marginTop: '15px' }}>
            <strong>Expenses:</strong>
            {debugInfo.expenses.map((expense: any, index: number) => (
              <div 
                key={index}
                style={{
                  background: 'rgba(0, 255, 0, 0.1)',
                  padding: '10px',
                  margin: '10px 0',
                  borderRadius: '5px',
                  border: '1px solid #00ff00'
                }}
              >
                <div><strong>Title:</strong> {expense.title}</div>
                <div><strong>Amount:</strong> ${expense.amount}</div>
                <div><strong>Paid By:</strong> {expense.paidBy}</div>
                <div><strong>Your Share:</strong> ${expense.yourShare}</div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ marginTop: '15px', color: 'var(--color-error)' }}>
            ⚠️ No expenses found in this group!
          </div>
        )}
      </div>
      ) : (
        <div style={{ lineHeight: '1.6' }}>
          <div><strong>Your User ID:</strong> {settleUpDebugInfo.userId}</div>
          <div><strong>Your Name:</strong> {settleUpDebugInfo.userName}</div>
          <div style={{ marginTop: '10px' }}><strong>Total Balances:</strong> {settleUpDebugInfo.totalBalances}</div>
          
          {settleUpDebugInfo.balances && settleUpDebugInfo.balances.length > 0 ? (
            <div style={{ marginTop: '15px' }}>
              <strong>Balances:</strong>
              {settleUpDebugInfo.balances.map((bal: any, index: number) => (
                <div 
                  key={index}
                  style={{
                    background: bal.balance > 0 ? 'rgba(0, 255, 0, 0.1)' : 'rgba(255, 107, 107, 0.1)',
                    padding: '10px',
                    margin: '10px 0',
                    borderRadius: '5px',
                    border: bal.balance > 0 ? '1px solid #00ff00' : '1px solid #ff6b6b'
                  }}
                >
                  <div><strong>User:</strong> {bal.user} (ID: {bal.userId})</div>
                  <div><strong>Balance:</strong> ${Math.abs(bal.balance).toFixed(2)} {bal.currency}</div>
                  <div><strong>Meaning:</strong> {bal.interpretation}</div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ marginTop: '15px', color: 'var(--color-error)' }}>
              ⚠️ No balances to settle!
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DebugPanel;

